/**
 * Route copy for `src/routes/social` (keys: `routes.social.<file>.<key>`).
 *
 * `fr` is the source; `en` and `ar` are typed against it, so a missing or extra
 * key fails `tsc` (and parity.test.ts). Keys are referenced from the route files
 * through `t()` / `tr()` — edit values freely, never rename a key without its call site.
 *
 * Locale file: en (typed against ./fr). One file per locale so
 * every non-default locale is a separate, lazily-loaded chunk.
 */

import type { Catalog } from './fr';

const en: Catalog = {
  socialLeadsPage: {
    errorsCount: '{{errors}} error(s)',
    myAudience: 'My audience',
    discover: 'Discover',
    leadAds: 'Lead Ads',
    linkedinSalesNavImport: 'LinkedIn / Sales Nav import',
    socialLeads: 'Social leads',
    extractLeadsFromYourLegitimateSources: 'Extract leads from your legitimate sources: your audience, public discovery and your Lead Ads. Compliant with the platforms\' terms of service.',
    readOnlyAddingToTheCrm: '🔒 Read-only — adding to the CRM requires a role with write permissions.',
    socialLeadsNavigation: 'Social leads navigation',
    group: 'Group:',
    targetGroup: 'Target group',
    none: 'None',
    newGroup: '➕ New group…',
    newGroupName: 'New group name',
    createdCreated: '{{created}} created',
    existingAlreadyPresent: '{{existing}} already present',
    groupedAddedToTheGroup: '{{grouped}} added to the group',
    selectAll: 'Select all',
    name: 'Name',
    platform: 'Platform',
    followers: 'Followers',
    profile: 'Profile',
    selectName: 'Select {{name}}',
    open: 'Open ↗',
    accountNotConnected: 'Account not connected',
    manageConnectedAccounts: 'Manage connected accounts →',
    conversations: 'Conversations',
    unread: 'Unread',
    platforms: 'Platforms',
    selection: 'Selection',
    n14DayActivity: '14-day activity',
    conversationActivityOver14Days: 'Conversation activity over 14 days',
    results: 'Results',
    selected: 'Selected',
    withEmail: 'With email',
    avgFollowers: 'Avg. followers',
    followerBreakdownAmongTheResults: 'Follower breakdown among the results',
    audienceAddedToTheCrmV: 'Audience added to the CRM — {{v}}',
    addingToTheCrmFailed: 'Adding to the CRM failed.',
    thePeopleWhoWroteToYou: 'The people who wrote to you (comments, DMs, mentions) are legitimate leads. Select conversations and add their authors to the CRM.',
    loadingConversations: 'Loading conversations…',
    noConversationInTheInbox: 'No conversation in the inbox.',
    contact: 'Contact',
    type: 'Type',
    adding: 'Adding…',
    addToTheCrmSize: 'Add to the CRM ({{size}})',
    theSearchFailedQuotaOrApi: 'The search failed (quota or API error).',
    addingToTheCrmV: 'Adding to the CRM — {{v}}',
    discoveryOfPublicProAccountsMeta: 'Discovery of public pro accounts (Meta business_discovery)',
    publicUsername: 'public @username',
    username: 'Username',
    search: 'Search',
    youtubeSearch: 'YouTube search',
    keywordsChannelOrVideo: 'Keywords (channel or video)',
    channels: 'Channels',
    videos: 'Videos',
    searching: 'Searching…',
    couldNotLoadTheLeadAds: 'Could not load the Lead Ads forms.',
    couldNotLoadTheLeads: 'Could not load the leads.',
    leadsAddedToTheCrmV: 'Leads added to the CRM — {{v}}',
    loadingForms: 'Loading forms…',
    yourMetaLeadAdsSubmissionsPeople: 'Your Meta Lead Ads submissions — people who voluntarily left their contact details. Choose a form, then add the leads to the CRM.',
    form: 'Form:',
    leadAdsForm: 'Lead Ads form',
    select: 'Select…',
    loadingLeads: 'Loading leads…',
    termsOfServiceLimitsPleaseRead: 'Terms-of-service limits — please read',
    theLinkedinApi: 'The LinkedIn API',
    doesNotAllow: 'does not allow',
    peopleSearchOrAutomatedConnectionRequest: 'people search or automated connection requests / messages. No scraping is performed here.',
    metaForbidsColdDmsLeadsCome: 'Meta forbids cold DMs. Leads come only from your audience, your Lead Ads or public accounts (business_discovery).',
    connectContactIsDone: '“Connect / contact” is done',
    manually: 'manually',
    viaTheLinksBelowOpeningThe: 'via the links below (opening the profile), never automatically. For WhatsApp, respect the contact\'s prior opt-in.',
    importACsvExportSalesNavigator: 'Import a CSV export (Sales Navigator / LinkedIn)',
    exportYourProspectsFromSalesNavigator: 'Export your prospects from Sales Navigator / LinkedIn as CSV, then import them with the CRM import assistant (email deduplication included).',
    openTheCrmImportAssistant: 'Open the CRM import assistant →',
    openAProfileManuallyDeepLink: 'Open a profile manually (deep link)',
    searchOpenedInLinkedinInA: 'Search opened in LinkedIn in a new tab — manual action, compliant with the terms of service.',
    nameTitleCompany: 'Name, title, company…',
    manualLinkedinSearch: 'Manual LinkedIn search',
    openInLinkedin: 'Open in LinkedIn ↗',
  },
};

export default en;
